<img src="../../../assets/images/translucentOhaLogo.png" class="bg hideOnMobile" alt="Oregon Health Authority Logo" aria-label="Oregon Health Authority Logo">

<img src="../../../assets/images/translucentOhaLogo.png" class="bg-mobile showOnMobile" alt="Oregon Health Authority Logo" aria-label="Oregon Health Authority Logo">

<div *ngIf="!loggingIn" fxLayout="column" fxLayoutGap="8px" fxLayoutAlign="start center" fxLayoutAlign.lt-sm="">
  <!-- B2C Login options -->
  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="150px" fxLayoutGap.lt-sm="25px" *ngIf="isB2C()">
    <div fxLayout="column" fxLayoutGap="8px" fxLayoutAlign="start center">
      <span style="font-size: x-large;"> <strong>Already have an account?</strong> </span>
      <button mat-stroked-button (click)="login()" color="primary">
        <span class="f-s-20"> Login</span>
      </button>
    </div>
    <div fxLayout="column" fxLayoutGap="16px">
      <div fxLayout="column" fxLayoutGap="8px" fxLayoutAlign="start center">
        <span style="font-size: x-large;"> <strong>New user?</strong> </span>
      </div>

      <div fxLayout="column" fxLayoutGap="24px">
        <div fxLayout="row" fxLayoutAlign="space-around center">
          <button mat-raised-button color="primary" (click)="login()">Let's Get Started!</button>
        </div>
      </div>
    </div>
  </div>
  <!-- AAD Login options -->
  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="150px" fxLayoutGap.lt-sm="25px" *ngIf="isAAD()">
    <div fxLayout="column" fxLayoutGap="32px" fxLayoutAlign="center center" class="p-t-32">
      <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign.lt-md="center center" fxLayoutGap="8px">
       <span style="font-family: Oswald; font-size: 30pt;">Portal Administration</span>
      </div>
     <button mat-button (click)="login()" color="primary">
       <span class="f-s-20 p-32">Enter</span>
     </button>
  </div>
</div>

<div *ngIf="loggingIn">
  <div id="globalLoader" class="global-loader">
    <h1>Loading...</h1>
  </div>
</div>
